import { useEffect } from 'react';
import { FeedUI } from './types';
import pulseClient from '../pulse-tracking';
import Transaction from './Transaction';

const TransactionFeed = ({ uiData }: { uiData?: FeedUI }) => {
    const shouldShowFeed = !!uiData?.transactions[0];

    // Tracking with pulse if any content is visible
    useEffect(() => {
        if (shouldShowFeed) {
            pulseClient.trackFeedView();
        }
    }, [shouldShowFeed]);

    // For fetch errors or when user has no transactions in their feed
    if (!uiData || !shouldShowFeed) {
        return null;
    }

    return (
        // TODO: section should have an aria-label or heading
        <section className="mt-12">
            <Transaction transaction={uiData.transactions[0]} />
        </section>
    );
};

export default TransactionFeed;
